import { create } from "zustand";
import { SubscriptionType } from "../../constants/subscriptionConst";
import { WLSubscriptionsTiers } from "../../../Common/models/subscriptions";

export type WLResponseIcon = SubscriptionType | "none";

interface WLResponseDialogProps {
  icon: WLResponseIcon;
  title: string;
  description: string;
  onConfirm: () => void;
  onConfirmText: string;
  onCancel?: () => void;
  onCancelText?: string;
  subscription?: WLSubscriptionsTiers;
  hideSuccessAnimation?: boolean;
}

interface WLSubscriptionResponseDialogState {
  isOpen: boolean;
  icon: WLResponseIcon;
  title: string;
  description: string;
  onConfirmText: string;
  onConfirm: () => void;

  onCancelText?: string;
  onCancel?: () => void;

  showDialog: (props: WLResponseDialogProps) => void;
  hideDialog: () => void;
  reset: () => void;
  subscription?: WLSubscriptionsTiers;
  hideSuccessAnimation?: boolean;
}

export const useWLSubscriptionResponseDialog =
  create<WLSubscriptionResponseDialogState>((set) => ({
    isOpen: false,
    icon: "none",
    title: "",
    description: "",
    onConfirmText: "Okay",
    subscription: undefined,
    hideSuccessAnimation: undefined,
    onConfirm: () =>
      set({
        isOpen: false,
      }),
    showDialog: (props) =>
      set({
        ...props,
        onConfirm: async () => {
          await props.onConfirm();
          set({ isOpen: false });
        },
        isOpen: true,
      }),
    hideDialog: () =>
      set({
        isOpen: false,
      }),
    reset: () =>
      set({
        onConfirmText: "Okay",
        onConfirm: () =>
          set({
            isOpen: false,
          }),
        onCancelText: undefined,
        onCancel: undefined,
        subscription: undefined,
        isOpen: false,
        icon: "none",
        hideSuccessAnimation: undefined,
      }),
  }));
